<template>
    <b-container id="view-credits-create" fluid v-if="$can('view-credits-create') || $can('view-all')">
        <b-row class="page-title">
            <b-container fluid>
                <b-row>
                    <b-col cols="7">
                        <h3>Credit Memo - Create</h3>
                    </b-col>
                    <b-col cols="2" class="text-right">
                        <b-form inline>
                            <label class="mr-sm-2" for="inline-form-select-wh">Location</label>
                            <b-form-select id="inline-form-select-wh" class="mb-2 mr-sm-2 mb-sm-0"
                                v-model="datasets.core.location" :options="datasets.locations" size="sm">
                            </b-form-select>
                        </b-form>
                    </b-col>
                    <b-col cols="2" class="text-right">
                        <b-form inline>
                            <label class="mr-sm-2" for="inline-form-select-status">Status</label>
                            <b-form-select id="inline-form-select-status" class="mb-2 mr-sm-2 mb-sm-0"
                                v-model="datasets.core.status" :options="statusOptions" size="sm"></b-form-select>
                        </b-form>
                    </b-col>
                    <b-col cols="1">
                        <b-button type="submit" variant="success" @click="create" class="btn-sm"
                            :disabled="!datasets.core.customer">
                            <span v-if="submitting">
                                <b-spinner small type="grow"></b-spinner>
                                Creating...
                            </span>
                            <span v-else>Create</span>
                        </b-button>
                    </b-col>
                </b-row>
                <hr />
            </b-container>
        </b-row>
        <b-row :key="pageKey">
            <b-col>
                <b-form-row>
                    <b-col>
                        <b-form-group id="select-group-source" label="Source:" label-for="select-source"
                            label-size="sm">
                            <b-form-select v-model="datasets.core.source" :options="datasets.sources" size="sm">
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group id="datepicker-group-date" label="Date:" label-for="datepicker-date"
                            label-size="sm">
                            <b-form-datepicker id="datepicker-date" v-model="datasets.core.date" class="mb-2" size="sm"
                                :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                locale="en">
                            </b-form-datepicker>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group id="input-group-customer" label="Customer:" label-for="input-customer"
                            label-size="sm">
                            <div class="options-assign">
                                <div class="autosuggest-container">
                                    <vue-autosuggest v-model="datasets.core.customer"
                                        :suggestions="autosuggest.customer.suggestions" @click="clickHandlerCustomer"
                                        @input="fetchResultsCustomer" @selected="onSelectedCustomer"
                                        @keydown.tab="suggestFirstCustomer($event.target.value)"
                                        :get-suggestion-value="getSuggestionValueCustomer"
                                        :input-props="{id:'autosuggest__input', placeholder:''}"
                                        @keyup.enter="suggestFirstCustomer($event.target.value)"
                                    >

                                        <b-container slot-scope="{suggestion}" fluid>
                                            <b-row>
                                                <b-col class="text-right">
                                                    {{ suggestion.item.name }} ({{suggestion.item.id}})
                                                </b-col>
                                            </b-row>
                                        </b-container>
                                    </vue-autosuggest>
                                </div>
                            </div>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-row>
                            <b-col>
                                <b-form-group id="input-group-email" label="Email:" label-for="input-email" label-size="sm">
                                    <b-form-input id="input-email" v-model="datasets.core.email" type="text" size="sm" autocomplete="off">
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col cols="2">
                                <b-form-checkbox id="checkbox-1" name="checkbox-1" value="1" v-model="datasets.core.emailSend" unchecked-value="0"
                                    size="sm">
                                    Send copy
                                </b-form-checkbox>
                            </b-col>
                        </b-form-row>
                    </b-col>
                </b-form-row>
                <b-form-row>
                    <b-col>
                        <b-form-group id="input-group-reference" label="Reference:" label-for="input-reference" label-size="sm">
                            <b-form-input id="input-reference" v-model="datasets.core.reference" type="text" size="sm" autocomplete="off">
                            </b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="6">
                        <b-form-group id="input-group-tags" label="Tags:" label-for="input-tags" label-size="sm">
                            <vue-tags-input v-model="tags.currentTag" :tags="datasets.core.tags" :autocomplete-items="filteredTags"
                                @tags-changed="newTags => datasets.core.tags = newTags" placeholder="" />
                        </b-form-group>
                    </b-col>
                </b-form-row>
            </b-col>
        </b-row>
        <b-row>
            <b-container fluid>
                <b-table-simple hover small responsive bordered sticky-header="430px">
                    <b-thead>
                        <b-tr>
                            <b-th class="text-center th-number">#</b-th>
                            <b-th></b-th>
                            <b-th>Title</b-th>
                            <b-th>SKU</b-th>
                            <b-th class="text-center">QTY</b-th>
                            <b-th class="text-center">Price</b-th>
                            <b-th class="text-center">Total</b-th>
                            <b-th>Notes</b-th>
                            <b-th class="text-center">Restock</b-th>
                            <b-th></b-th>
                        </b-tr>
                    </b-thead>
                    <b-tbody>
                        <b-tr v-for="(item, index) in datasets.rows" :key="index" :class="`index-${index}`">
                            <td class="text-center">
                                {{ index + 1 }}
                            </td>
                            <td class="text-center">
                                <b-img-lazy v-if="item.url" class="products-thumbs" :src="item.url"></b-img-lazy>
                            </td>
                            <td>
                                <b-form-input v-model="datasets.rows[index].description" size="sm" class="text-center"
                                    :ref="'titleinput' + index" @keyup.13="nextRow(index, 'title')"
                                    @focus="focusMeRow(index)" disabled></b-form-input>
                            </td>
                            <td>
                                <autosuggest-instance :key="index" :idx="index" @nextRow="nextRow"
                                    @suggestFirstRow="suggestFirstRow" @onSelectedRow="onSelectedRow"
                                    @focusMeRow="focusMeRow(index)" :ref="'skuinput' + index" />
                                <strong>Vendor:</strong> {{ item.vendor }}<br />
                                <strong>MPN:</strong> {{ item.mpn }}
                            </td>
                            <td>
                                <b-form-input v-model="datasets.rows[index].qty" size="sm" class="text-center"
                                    @input="calculateRow(index)" :ref="'qtyinput' + index"
                                    @keyup.13="nextRow(index, 'qty')" @focus="focusMeRow(index)"></b-form-input>
                                <div class="text-center">
                                    QOH: <span v-if="item.qoh">{{ item.qoh || 0 }}</span><span v-else>0</span><br />
                                    Available: <span v-if="item.available">{{ item.available || 0 }}</span><span
                                        v-else>0</span><br />
                                </div>
                            </td>
                            <td>
                                <b-form-input v-model="datasets.rows[index].rate" size="sm" class="text-center"
                                    @input="calculateRow(index)" :ref="'rateinput' + index"
                                    @keyup.13="nextRow(index, 'rate')" @focus="focusMeRow(index)"
                                ></b-form-input>
                                <div class="text-center" v-if="$can('view-product-cost') || $can('view-all')">
                                    Last Cost: $<span v-if="item.lastCost">{{ numberWithCommas(item.lastCost) || '0.00'
                                    }}</span><span v-else>0</span><br />
                                    Avg Cost:
                                </div>
                            </td>
                            <td>
                                <b-form-input v-model="datasets.rows[index].amount" size="sm" class="text-center"
                                    disabled></b-form-input>
                            </td>
                            <td>
                                <b-form-input v-model="datasets.rows[index].notes" size="sm" class="text-center"
                                    :ref="'notesinput' + index" @keyup.13="nextRow(index, 'notes')"
                                    @focus="focusMeRow(index)"></b-form-input>
                            </td>
                            <td class="text-center">
                                <b-form-checkbox :id="'checkbox-restock-' + index" :name="'checkbox-restock-' + index" value="1" v-model="datasets.rows[index].restock" unchecked-value="0">
                                </b-form-checkbox>
                            </td>
                            <td class="text-center">
                                <b-button size="sm" variant="danger" @click="deleteRow(index)"><i
                                        class="far fa-trash-alt"></i></b-button>
                            </td>
                        </b-tr>
                    </b-tbody>
                </b-table-simple>

                <b-row>
                    <b-col cols="1">
                        <b-button size="sm" @click="addTenRows"><i class="fas fa-plus"></i> 10</b-button>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="4">
                        <b-row>
                            <b-col cols="12">
                                <b-form-group id="textarea-group-order-notes" label="Notes:"
                                    label-for="textarea-order-notes" label-size="sm">
                                    <b-form-textarea id="textarea-order-notes" v-model="datasets.core.internalNote"
                                        placeholder="" rows="8" size="sm" no-resize></b-form-textarea>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="8" class="text-right">
                        <b-table-simple hover small responsive>
                            <b-tbody>
                                <b-tr>
                                    <b-td></b-td>
                                    <b-td class="table-totals-col"><strong>Subtotal:</strong></b-td>
                                    <b-td class="table-totals-col">${{ numberWithCommas(datasets.core.subtotal) ||
                                    '0.00' }}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td></b-td>
                                    <b-td><strong>Total:</strong></b-td>
                                    <b-td>${{ numberWithCommas(datasets.core.total) || '0.00' }}</b-td>
                                </b-tr>
                            </b-tbody>
                        </b-table-simple>
                    </b-col>
                </b-row>
            </b-container>
        </b-row>
    </b-container>
</template>

<script>
import { VueAutosuggest } from "vue-autosuggest"
import AutosuggestInstance from '../../../pages/user/inventory/products/AutosuggestInstance'
import VueTagsInput from '@johmun/vue-tags-input'
export default {
    name: 'CreditsCreate',

    props: ['customerId'],

    metaInfo() {
        return {
            title: 'Credit Memos - Create',
        }
    },

    components: {
        VueAutosuggest,
        AutosuggestInstance,
        VueTagsInput
    },

    data() {
        return {
            datasets: {
                locations: [],
                core: {
                    date: this.getDate(),
                    emailSend: 0,
                    status: 'Open',
                    source: 'Phone',
                    tags: [],
                    location: 'BSG'
                },
                rows: [],
                statuses: [
                    'Open',
                    'Confirmed',
                    'Closed',
                    'Cancelled'
                ],
                sources: [
                    'Website',
                    'E-mail',
                    'Fax',
                    'Phone',
                    'Tradeshow',
                    'Walk In'
                ]
            },
            tags: {
                list: [],
                currentTag: ''
            },
            autosuggest: {
                customer: {
                    suggestions: [],
                    debounceMilliseconds: 500,
                    timeout: null
                },
                row: {
                    suggestions: [],
                    debounceMilliseconds: 500,
                    timeout: null,
                    currentIndex: '',
                }
            },
            modals: {

            },
            submitting: 0,
            pageKey: 1
        }
    },
    methods: {
        nextRow(idx, col) {
            let target = col + 'input' + (idx + 1)

            if (col == 'sku') {
                this.$refs[target][0].$el.childNodes[0].childNodes[0].childNodes[0].childNodes[0].focus()
            } else {
                this.$refs[target][0].$el.focus()
            }
        },

        openModal(modalName, row, area) {
            let prefix = 'modal-orders-credits-'
            switch (modalName) {

            }

            this.$nextTick(() => {
                this.$bvModal.show(prefix + modalName)
            })
        },

        closeModal(modalName) {
            this.$bvModal.hide(modalName)
        },

        toggleBusy() {
            this.tables.salesOrders.isBusy = !this.tables.salesOrders.isBusy
        },

        addTenRows() {
            for (var index = 0; index <= 10; index++) {
                this.datasets.rows.push({ sku: '', description: '', qty: '', rate: '', rateOriginal: '', amount: '', url: '', available: 0 })
            }
        },

        getOrderTags() {
            let url = 'api/orders/sales-orders/getordertags'
            axios.get(url, {})
                .then((res) => {
                    this.tags.list = res.data.tags
                }, () => {
                    this.has_error = true
                })
        },

        deleteRow(index) {
            let previousSkus = []
            this.datasets.rows.forEach((row, idx, array) => {
                if (row.sku && idx != index) {
                    previousSkus.push(row.sku)
                }
            })

            let target = 'skuinput' + (index + 1)

            if (this.datasets.rows.length == 1 && index == 0) {
                this.datasets.rows[0].sku = ''
                this.datasets.rows[0].description = ''
                this.datasets.rows[0].qty = ''

                this.datasets.rows[0].rate = ''
                this.datasets.rows[0].rateOriginal = ''
                this.datasets.rows[0].amount = ''
                this.datasets.rows[0].url = ''
            } else {
                this.datasets.rows.splice(index, 1)
            }

            this.datasets.rows.forEach((row, idx, array) => {
                if (row.sku) {
                    this.$refs['skuinput' + idx][0].$el.childNodes[0].childNodes[0].childNodes[0].childNodes[0].value = previousSkus[idx]
                    this.$refs['skuinput' + idx][0].query = row.sku
                } else {
                    this.$refs['skuinput' + idx][0].$el.childNodes[0].childNodes[0].childNodes[0].childNodes[0].value = ''
                    this.$refs['skuinput' + idx][0].query = ''
                }
            })

            this.calculateTotals()
        },

        calculateRow(index) {
            let qty = this.datasets.rows[index].qty > 0 ? this.datasets.rows[index].qty : 0
            let activeQty = qty
            let rate = this.datasets.rows[index].rate ? this.datasets.rows[index].rate : 0
            let amount = 0

            amount = Number(activeQty) * this.datasets.rows[index].rate

            this.datasets.rows[index].amount = amount.toFixed(2)

            this.calculateTotals()
        },

        calculateTotals() {
            let subtotal = Number(0)
            this.datasets.rows.forEach((row, idx, array) => {
                let activeQty = row.qty
                subtotal += row.rate * activeQty
            })
            this.datasets.core.subtotal = parseFloat(subtotal).toFixed(2)

            let total = Number(0)
            this.datasets.core.total = parseFloat(subtotal).toFixed(2)
        },

        focusMeRow(index) {
            if (this.datasets.rows.length == index + 1) {
                this.datasets.rows.push({ sku: '', description: '', qty: '', rate: '', rateOriginal: '', amount: '', url: '' })

                this.scrollToElement({ behavior: 'smooth' }, index + 1)
            }

        },

        clickHandlerCustomer(item) {
            let query = this.datasets.core.customer
            if (!query) {
                this.autosuggest.customer.suggestions = []
            }
        },

        fetchResultsCustomer() {
            const query = this.datasets.core.customer

            clearTimeout(this.autosuggest.customer.timeout);
            this.autosuggest.customer.timeout = setTimeout(() => {
                const customersPromise = axios.get('api/lists/customers/getcustomersfilter/' + query);

                Promise.all([customersPromise]).then(values => {
                    this.autosuggest.customer.suggestions = []

                    const customers = values[0].data.items

                    customers.length &&
                        this.autosuggest.customer.suggestions.push({ name: "customers", data: customers })

                    if (!isNaN(query)) {
                        this.datasets.core.customer = this.autosuggest.customer.suggestions[0].data[0].name
                        this.onSelectedCustomer({ item: this.autosuggest.customer.suggestions[0].data[0] })
                    }
                })
            }, this.autosuggest.customer.debounceMilliseconds)
        },

        fetchResultsRow() {
            const query = this.datasets.rows[this.autosuggest.row.currentIndex].sku

            clearTimeout(this.autosuggest.row.timeout);
            this.autosuggest.row.timeout = setTimeout(() => {
                const productsPromise = axios.get('api/inventory/generatepicturefile/getproductsfilter/' + query);

                Promise.all([productsPromise]).then(values => {
                    this.autosuggest.row.suggestions[this.autosuggest.row.currentIndex] = []

                    const products = values[0].data.items

                    products.length &&
                        this.autosuggest.row.suggestions[this.autosuggest.row.currentIndex].push({ name: "products", data: products })
                })
            }, this.autosuggest.row.debounceMilliseconds)
        },

        onSelectedCustomer(item) {
            if (item) {
                this.datasets.core.customer = item.item.name
                this.datasets.core.customerId = item.item.id
                this.datasets.core.email = item.item.email
                // this.datasets.core.internalNote = 'Customer Notes: ' + item.item.notes

                this.pageKey++
            }
        },

        onSelectedRow(idx, sku, description, rate, url, qoh, cost, binA, binB, urlMed, available, mpn, lastCost, qoo, vendor) {
            this.datasets.rows[idx].sku = sku
            this.datasets.rows[idx].description = description
            this.datasets.rows[idx].rate = rate
            this.datasets.rows[idx].rateOriginal = rate
            this.datasets.rows[idx].url = url
            this.datasets.rows[idx].qoh = qoh
            this.datasets.rows[idx].cost = cost
            this.datasets.rows[idx].available = available
            this.datasets.rows[idx].lastCost = lastCost
            this.datasets.rows[idx].vendor = vendor

            this.calculateRow(idx)
        },

        onKeyTabCustomer(evt) {
            let query = this.datasets.core.customer.toLowerCase()

            setTimeout(() => {
                if (this.autosuggest.customer.suggestions.length) {
                    let results = this.autosuggest.customer.suggestions[0].data

                    let resultName = results[0].name

                    if (resultName == query) {
                        this.datasets.core.customer = results[0].name
                        this.datasets.core.customerId = results[0].id
                        this.datasets.core.email = results[0].email
                        // this.datasets.core.internalNote = 'Customer Notes: ' + results[0].notes
                        this.autosuggest.customer.suggestions = []
                    } else {
                        this.autosuggest.customer.suggestions = []
                    }
                }
            }, 1500)
        },

        getSuggestionValueCustomer(suggestion) {
            return suggestion.item.name
        },

        getSuggestionValueRow(suggestion) {
            return suggestion.item.name
        },

        suggestFirstCustomer(query) {
            let suggests = this.autosuggest.customer.suggestions
            let arr = suggests[0].data

            if (arr.length) {
                for (var i = 0; i < arr.length; i++) {
                    let cur = arr[i].name.toLowerCase()
                    if (cur.includes(query.toLowerCase())) {
                        this.datasets.core.customer = arr[i].name
                        this.datasets.core.customerId = arr[i].id
                        this.datasets.core.email = arr[i].email
                        this.autosuggest.customer.suggestions = []

                        break;
                    } else {
                        continue
                    }
                }
            }
        },

        suggestFirstRow(idx, sku, description, rate, url, qoh, cost, available, mpn, lastCost, qoo, vendor) {
            this.datasets.rows[idx].sku = sku
            this.datasets.rows[idx].description = description
            this.datasets.rows[idx].rate = rate
            this.datasets.rows[idx].rateOriginal = rate
            this.datasets.rows[idx].url = url
            this.datasets.rows[idx].qoh = qoh
            this.datasets.rows[idx].cost = cost
            this.datasets.rows[idx].available = available
            this.datasets.rows[idx].lastCost = lastCost
            this.datasets.rows[idx].vendor = vendor

            this.calculateRow(idx)
        },

        create() {
            this.submitting = 1

            let url = 'api/orders/creditmemos/create'
            axios.post(url, {
                core: this.datasets.core,
                rows: this.datasets.rows
            })
                .then((res) => {
                    this.submitting = 0

                    if (res.data.status == 'success') {

                        this.showAlertBox('success', 'Credit Memo Created', 'Credit Memo created successfully!')
                        this.$router.push({ name: 'CreditsDetail', params: { creditNum: res.data.creditId } })
                    } else {
                        this.showAlertBox('error', 'Error Creating Credit Memo', res.data.status)
                    }
                }, () => {
                    this.has_error = true
                })
        },

        resetView() {
            this.datasets.rows = []

            for (var index = 0; index <= 2; index++) {
                this.datasets.rows.push({ sku: '', description: '', qty: '', rate: '', rateOriginal: '', amount: '', url: '', available: 0 })
                this.autosuggest.row.suggestions.push([])
            }

            this.currentIndex = ''
        }
    },

    computed: {
        filteredTags() {
            return this.tags.list.filter(i => {
                return i.text.toLowerCase().indexOf(this.tags.currentTag.toLowerCase()) !== -1;
            })
        },
        statusOptions() {
            return this.datasets.statuses.map(status => {
                if (status === 'Closed') {
                    return { value: 'Closed', text: 'Ready' };
                }
                return { value: status, text: status };
            });
        }
    },

    watch: {
        'datasets.core.status'(newVal) {
            // If user somehow selects "Ready" (which shouldn't happen), convert it back to "Closed"
            if (newVal === 'Ready') {
                this.datasets.core.status = 'Closed';
            }
        }
    },

    mounted() {
        if (this.customerId) {
            this.datasets.core.customer = this.customerId.toString()
            this.fetchResultsCustomer()
        }

        this.getOrderTags()
        this.datasets.locations = Object.keys(this.getLocations)

        this.resetView()

        this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
            switch (modalId) {

            }
        })
    }
}
</script>
<style lang="scss">
#credits-create {
    .table-totals-col {
        width: 20%;
    }

    .products-thumbs {
        max-width: 75px;
        max-height: 75px;
    }

    .th-number {
        width: 40px;
    }

    .vue-tags-input {
        max-width: 100%;

        .ti-input {
            display: block;
            width: auto;
            height: calc(1.2em + 0.75rem + 2px);
            // padding: 0.375rem 0.75rem;
            font-size: 1rem;
            font-weight: 400;
            line-height: 1.5;
            color: #495057;
            background-color: #fff;
            background-clip: padding-box;
            border: 1px solid #ced4da;
            border-radius: 0.25rem;
            transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
        }
    }

    .options-assign {
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;

        input {
            width: 100%;
            padding: 0.5rem;
            height: calc(1.5em + 0.3rem + 2px);
        }

        ul {
            width: 100%;
            color: rgba(30, 39, 46, 1.0);
            list-style: none;
            margin: 0;
            padding: 0.5rem 0 .5rem 0;
        }

        li {
            margin: 0 0 0 0;
            border-radius: 5px;
            padding: 0.75rem 0 0.75rem 0.75rem;
            display: flex;
            align-items: center;
        }

        li:hover {
            cursor: pointer;
        }

        .autosuggest-container {
            display: flex;
            // justify-content: center;
            width: 100%;

            li {
                white-space: nowrap;
                text-align: left;
            }
        }

        #autosuggest {
            width: 100%;
            display: block;
        }

        .autosuggest__results {
            position: relative;
        }

        .autosuggest__results-container {
            width: 300px;
        }

        .autosuggest__results-item--highlighted {
            background-color: rgba(51, 217, 178, 0.2);
        }

        #autosuggest-autosuggest__results {
            overflow-y: hidden;
            // max-height: 200px;
        }
    }
}
</style>
